<div class="dialog-padding">
  <h1 mat-dialog-title>Fare Review and Adjustment History</h1>
  <div mat-dialog-content>
    <ng-container *ngFor="let driverFareCalculation of data.driverFareCalculations">
      <ng-container *ngIf="!(driverFareCalculation.active && driverFareCalculation.estimate)">
        <mat-card appearance="outlined">
          <p>
            <label id="driverFareCalculationHistory-text-adjustmentHistoryLabel-{{ driverFareCalculation.fareCalculationId }}">{{
              getLabelText(driverFareCalculation)
            }}</label>
            <span id="driverFareCalculationHistory-text-adjustmentHistoryDateTime-{{ driverFareCalculation.fareCalculationId }}">{{
              getDate(driverFareCalculation)
            }}</span>
          </p>
          <table>
            <tr class="header-row">
              <th class="fare-header">Fare</th>
              <th class="estimated-header">Estimated</th>
              <th class="actual-header">Actual</th>
            </tr>
            <tr>
              <td id="driverFareCalculationHistory-text-distanceLabel-{{ driverFareCalculation.fareCalculationId }}">Distance</td>
              <td id="driverFareCalculationHistory-text-estimatedDistance-{{ estimate.fareCalculationId }}">
                {{ estimate.distanceMiles }} mi
              </td>
              <td id="driverFareCalculationHistory-text-actualDistance-{{ driverFareCalculation.fareCalculationId }}">
                {{ driverFareCalculation.distanceMiles }} mi
              </td>
            </tr>
            <tr>
              <td id="driverFareCalculationHistory-text-durationLabel-{{ driverFareCalculation.fareCalculationId }}">Duration</td>
              <td id="driverFareCalculationHistory-text-estimatedDuration-{{ estimate.fareCalculationId }}">
                {{ estimate.durationInMinutes }} min
              </td>
              <td id="driverFareCalculationHistory-text-actualDuration-{{ driverFareCalculation.fareCalculationId }}">
                {{ driverFareCalculation.durationInMinutes }} min
              </td>
            </tr>

            <tr>
              <td id="driverFareCalculationHistory-text-incentiveLabel-{{ driverFareCalculation.fareCalculationId }}">Incentive</td>
              <td id="driverFareCalculationHistory-text-estimatedIncentive-{{ estimate.fareCalculationId }}">
                {{ estimate.providerIncentive | currency }}
              </td>
              <td id="driverFareCalculationHistory-text-actualIncentive-{{ driverFareCalculation.fareCalculationId }}">
                {{ driverFareCalculation.providerIncentive | currency }}
              </td>
            </tr>

            <tr>
              <td id="driverFareCalculationHistory-text-tollLabel-{{ driverFareCalculation.fareCalculationId }}">Toll</td>
              <td id="driverFareCalculationHistory-text-estimatedToll-{{ estimate.fareCalculationId }}">
                {{ estimate.tollReimbursement | currency }}
              </td>
              <td id="driverFareCalculationHistory-text-actualToll-{{ driverFareCalculation.fareCalculationId }}">
                {{ driverFareCalculation.tollReimbursement | currency }}
              </td>
            </tr>
            <tr>
              <td id="driverFareCalculationHistory-text-totalLabel-{{ driverFareCalculation.fareCalculationId }}" class="total">Total</td>
              <td id="driverFareCalculationHistory-text-estimatedTotal-{{ estimate.fareCalculationId }}">
                {{ estimate.totalProviderCommission | currency }}
              </td>
              <td id="driverFareCalculationHistory-text-actualTotal-{{ driverFareCalculation.fareCalculationId }}">
                {{ driverFareCalculation.totalProviderCommission | currency }}
              </td>
            </tr>
          </table>
        </mat-card>
      </ng-container>
    </ng-container>
  </div>
  <div mat-dialog-actions align="end">
    <button mat-stroked-button type="button" color="primary" (click)="close()">Close</button>
  </div>
</div>
